angular.module('unica_notification.notification_controllers')

.controller('NotificationCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	NotificationCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.resetNotificationData();

	$scope.getNotificationTemplateList();

	$scope.saveNotification = function()
	{
		$scope.showLoader();

		NotificationCreateService
			.create( $scope.event_id, $scope.notificationData )
			.then(function(data) {
				$scope.hideLoader();

				console.log(data);
				if ( data ) {
					$scope.showSuccessMsg('Notifica creata con successo!', '');

					$state.go('app.notification.assign', { event_id: $stateParams.event_id, id: data.id });
				}
			});
	};

});


